export default __webpack_public_path__ + "static/media/verified.756db5d0.png";